import React from 'react';
import LinkBase from './LinkBase';

const StandAloneLink = (props) => <LinkBase {...props} kind="standalone" />;

export default StandAloneLink;
